import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';

interface MarkdownContentProps {
    content: string;
}

export const MarkdownContent: React.FC<MarkdownContentProps> = ({ content }) => {
    return (
        <ReactMarkdown
            remarkPlugins={[remarkBreaks]}
            components={{
                a: ({ href, children }) => (
                    <a href={href} target='_blank' rel='noopener noreferrer'>
                        {children}
                    </a>
                ),
                img: () => null,
            }}
        >
            {content}
        </ReactMarkdown>
    );
};
